<div style="max-width: 800px">
  <div
    style="
      background-color: #f9f9f9;
      border-radius: 8px;
      border: 1px solid #dfdfdf;
      padding: 10px 10px 0 10px;
    "
  >
    <table style="margin-bottom: 10px; border-spacing: 5px">
      <tr>
        <td>Order:</td>
        <td>{{ carryOverTask?.order?.orderNumber }}</td>
      </tr>
      <tr>
        <td>Vehicle Value:</td>
        <td>
          {{
            (carryOverTask?.vehicle?.forecourtSale | currency : 'GBP' : 'symbol') ||
              'Not found. Please check the value yourself or see team leader.'
          }}
        </td>
      </tr>
      <tr>
        <td>Vehicle:</td>
        <td>
          <span class="carry-over-vrm">{{ carryOverTask?.vehicle?.registrationNumber }}</span>
          &nbsp; {{ carryOverTask?.vehicle?.make }} {{ carryOverTask?.vehicle?.model }}
        </td>
      </tr>
      <tr>
        <td>From:</td>
        <td class="flex">
          {{ carryOverTask?.pickupLocation?.postcode }}
          {{ carryOverTask?.pickupLocation?.city }}
          <span class="ml-1" *ngIf="carryOverTask?.taskSupplierSchedule"
            >({{
              carryOverTask?.taskSupplierSchedule?.specifiedPickUpTime | datex : 'ddd DD MMM HH:mm'
            }})</span
          >
        </td>
      </tr>
      <tr>
        <td>To:</td>
        <td class="flex">
          {{ carryOverTask?.dropoffLocation?.postcode }}
          {{ carryOverTask?.dropoffLocation?.city }}
          <span class="ml-1" *ngIf="carryOverTask?.taskSupplierSchedule"
            >({{
              carryOverTask?.taskSupplierSchedule?.specifiedDropOffTime
                | datex : 'ddd DD MMM HH:mm'
            }})</span
          >
        </td>
      </tr>
      <tr>
        <td>Direct Mileage:</td>
        <td>{{ carryOverTask?.taskMileage }} mi.</td>
      </tr>
      <tr *ngIf="carryOverTask?.carryoverAddress">
        <td>Requested Carryover Location:</td>
        <td>
          {{ carryOverTask?.carryoverAddress.addressLine }}
          <span *ngIf="carryOverTask?.isCarryoverAddressSupplierHome"> (Home)</span>
          <span *ngIf="!carryOverTask?.isCarryoverAddressSupplierHome"> (Other)</span>
        </td>
      </tr>
      <tr *ngIf="!carryOverTask?.carryoverAddress">
        <td>Assumed Carryover Location:</td>
        <td>Supplier's Home Address</td>
      </tr>
    </table>
  </div>

  <div style="margin-bottom: 20px; margin-top: 10px">
    <div style="font-weight: 500; margin-bottom: 5px">Carryover Approval Analysis</div>
    <div
      *ngFor="let step of carryOverTask?.preApproveCarryover.steps"
      class="mb-1 flex align-items-start gap-1"
    >
      <i
        class="fa fa-check fa-width"
        *ngIf="step.status == CarryoverCheckStatus.Passed"
        style="color: var(--success-colour)"
      ></i>
      <i
        class="fa fa-times fa-width"
        *ngIf="step.status == CarryoverCheckStatus.Failed"
        style="color: var(--danger-colour)"
      ></i>
      <i
        class="fa fa-warning fa-width"
        *ngIf="step.status == CarryoverCheckStatus.Warning"
        style="color: var(--yellow-400)"
      ></i>

      &nbsp;

      <span
        [class.acceptable]="step.status == CarryoverCheckStatus.Passed"
        [class.unacceptable]="step.status == CarryoverCheckStatus.Failed"
        >{{ step.comment }}</span
      >
    </div>
  </div>
</div>
